import { ModelSagres } from "../../model-sagres";
import { AditivoContrato } from "../aditivo-contrato/aditivo-contrato";
import { ArquivoContrato } from "./arquivo-contrato";
import { ContratoCentralizado } from "./contrato-centralizado";
import { ContratoLicitacaoOutraUg } from "./contrato-licitacao-outra-ug";
import { ContratoLicitacaoPropria } from "./contrato-licitacao-propria";
import { ContratoRegistroPreco } from "./contrato-registro-preco";
import { ParticipanteContrato } from "./participante-contrato";
import { TipoContrato } from "./tipo-contrato";

export class Contrato extends ModelSagres {
  IdContrato: number;
  IdUnidGestora: number;
  NrContrato: string;
  NrAnoContrato: number;
  DeObjetoContrato: string;
  CdCpfCnpjCredor: string;
  VlContrato: number;
  DeMotivoAnulacao: string;
  FlTipoProcedOrigem: string | null;
  NrEmpenho: number;
  NrAnoEmpenho: number;
  NmUsuarioUltimaAlteracao: string;
  IdTipoContrato: number | null;
  FlPagamentoAntecipado: string;
  DtInicioVigencia: Date;
  DtFimVigencia: Date;
  DtAssinatura: Date;
  DtAnulacao: Date;
  DtPublicacao: Date;
  DtUltimaAlteracao: Date;
  IdTipoContratoNavigation: TipoContrato;
  ContratoCentralizado: ContratoCentralizado;
  ContratoLicitacaoOutraUg: ContratoLicitacaoOutraUg;
  ContratoLicitacaoPropria: ContratoLicitacaoPropria;
  ContratoRegistroPreco: ContratoRegistroPreco;
  AditivoContrato: AditivoContrato[];
  ArquivoContrato: ArquivoContrato[];
  ContratoEmpenho: any[];
  ParticipanteContrato: ParticipanteContrato[];
  CdSituacao: string;

  NrContratoOrgaoResp: string;
  NrAnoContratoOrgaoResp: number;
  NrCnpjOrgaoResp: string;
  NmOrgaoResp: string;

  NrLicitacao: number;
  NrAnoLicitacao: number;
  IdModalidade: number;
  SgUf: string;
  NmMunicipio: string;

  IdUnidGestoraLicit: number;

  IdLicitacao: number;

  NumeroAnoContrato: string;
  ArquivoTextoContrato?: any;
  ArquivoAnulacao?: any;
  DescricaoProcedimentoOrigem: string;



  /**
   *
   */
  constructor() {
    super()
    this.IdTipoContrato = null;
    this.FlTipoProcedOrigem = null;    
  }

  tratarDadosDaAPI(): void {
    this.NumeroAnoContrato = `${this.NrContrato}/${this.NrAnoContrato}`;

    if (this.DtInicioVigencia) {
      this.DtInicioVigencia = new Date(this.DtInicioVigencia);
    }
    if (this.DtFimVigencia) {
      this.DtFimVigencia = new Date(this.DtFimVigencia);
    }
    if (this.DtAssinatura) {
      this.DtAssinatura = new Date(this.DtAssinatura);
    }
    if (this.DtAnulacao) {
      this.DtAnulacao = new Date(this.DtAnulacao);
    }
    if (this.DtPublicacao) {
      this.DtPublicacao = new Date(this.DtPublicacao);
    }
    if (this.DtUltimaAlteracao) {
      this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao);
    }

    if (this.ArquivoContrato) {
      const arqEdital = this.ArquivoContrato.find(x => x.IsArquivoEdital === true)
      const arqAnulacao = this.ArquivoContrato.find(x => x.IsArquivoEdital !== true)
      if(arqEdital !== undefined) this.ArquivoTextoContrato = Object.assign(new ArquivoContrato(), arqEdital)
      if(arqAnulacao !== undefined) this.ArquivoAnulacao = Object.assign(new ArquivoContrato(), arqAnulacao)
    }

    if(this.ContratoCentralizado !== undefined && this.ContratoCentralizado !== null) {
      this.NrContratoOrgaoResp = this.ContratoCentralizado.NrContratoOrgaoResp
      this.NrAnoContratoOrgaoResp = this.ContratoCentralizado.NrAnoContratoOrgaoResp
      this.NrCnpjOrgaoResp = this.ContratoCentralizado.NrCnpjOrgaoResp
      this.NmOrgaoResp = this.ContratoCentralizado.NmOrgaoResp
    }

    if(this.ContratoRegistroPreco !== undefined && this.ContratoRegistroPreco !== null) {
      this.NrLicitacao = this.ContratoRegistroPreco.NrLicitacao
      this.NrAnoLicitacao = this.ContratoRegistroPreco.NrAnoLicitacao
      this.IdModalidade = this.ContratoRegistroPreco.IdModalidade
      this.SgUf = this.ContratoRegistroPreco.SgUf
      this.NmMunicipio = this.ContratoRegistroPreco.NmMunicipio
      this.NrCnpjOrgaoResp = this.ContratoRegistroPreco.NrCnpjOrgaoResp
      this.NmOrgaoResp = this.ContratoRegistroPreco.NmOrgaoResp
    }

    if(this.ContratoLicitacaoPropria !== undefined && this.ContratoLicitacaoPropria !== null) {
      this.IdLicitacao = this.ContratoLicitacaoPropria.IdLicitacao
    }

    if(this.ContratoLicitacaoOutraUg !== undefined && this.ContratoLicitacaoOutraUg !== null) {
      this.NrLicitacao = this.ContratoLicitacaoOutraUg.NrLicitacao
      this.NrAnoLicitacao = this.ContratoLicitacaoOutraUg.NrAnoLicitacao
      this.IdModalidade = this.ContratoLicitacaoOutraUg.IdModalidade
      this.IdUnidGestoraLicit = this.ContratoLicitacaoOutraUg.IdUnidGestoraLicit
    }

    this.DescricaoProcedimentoOrigem = this.getDescricaoProcedimentoOrigem();
  }

  getTipoArquivo(tipo = 'edital') {
    if(tipo === 'edital') {
      if (this.ArquivoTextoContrato instanceof File) return "naosalvo";
      if (this.ArquivoTextoContrato instanceof ArquivoContrato) return "salvo";
    }
    else {
      if (this.ArquivoAnulacao instanceof File) return "naosalvo";
      if (this.ArquivoAnulacao instanceof ArquivoContrato) return "salvo";
    }
    return null;
  }

  private getDescricaoProcedimentoOrigem(): string {
    switch (this.FlTipoProcedOrigem) {
      case "R":
        return "Adesão a Ata de Registro de Preços";
      case "C":
        return "Contrato Centralizado";
      case "D":
        return "Dispensa, Art. 24, Incisos I e II e § 1º, Lei 8.666/93";
      case "B":
        return "Dispensa, Art. 29, Incisos I e II, Lei 13.303/2016";
      case "F":
        return "Dispensa, Art. 75, Incisos I e II, Lei 14.133/2021";
      case "U":
        return "Licitação de outra UG do mesmo Município";
      case "P":
        return "Licitação/Dispensa/Inexigibilidade Própria";    
      default:
        return "-";
    }
  }
}